module.exports = __webpack_public_path__ + "img/宣威市中医医院.8b6f1b17.png";